import { createSlice } from '@reduxjs/toolkit';

export const MAX_PROJECT_COUNT = 50;
export const PROJECT_COUNT_LIMIT_TOAST_ID = 'PROJECT_COUNT_LIMIT_TOAST_ID';

const initialState = {
  isInpainting: false,
  hasInpaintArea: false,
};

export const textureSlice = createSlice({
  name: 'initialState',
  initialState,
  reducers: {
    setIsInpainting: (state, action) => {
      state.isInpainting = action.payload;
    },
    setHasInpaintArea: (state, action) => {
      state.hasInpaintArea = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setIsInpainting, setHasInpaintArea } = textureSlice.actions;

export default textureSlice.reducer;
